var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazonS3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    id: "amazon-s3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C3123",
    points: "50.329 67.354 75.312 73.399 75.312 26.492 50.329 32.541"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E05243",
    points: "75.313 26.492 80.114 28.892 80.114 71.013 75.313 73.412"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E05243",
    points: "61.226 34.856 50.329 32.16 50.329 14 61.226 19.448"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E05243",
    points: "50.329 86 61.225 80.554 61.225 65.146 50.329 67.841"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E05243",
    points: "61.226 57.714 50.329 59.101 50.329 40.94 61.226 42.307"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E05243",
    points: "50.329 67.354 25.345 73.399 25.345 26.492 50.329 32.541"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C3123",
    points: "25.345 26.492 20.546 28.892 20.546 71.013 25.345 73.412"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C3123",
    points: "39.435 34.856 50.329 32.16 50.329 14 39.435 19.448"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C3123",
    points: "50.329 86 39.434 80.554 39.434 65.146 50.329 67.841"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C3123",
    points: "39.435 57.714 50.329 59.101 50.329 40.94 39.435 42.307"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5E1F18",
    points: "61.226 34.856 50.329 36.842 39.435 34.856 50.329 32.16"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F2B0A9",
    points: "61.226 65.145 50.329 63.146 39.435 65.145 50.329 67.858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonS3);
export default __webpack_public_path__ + "static/media/amazon-s3.21c8804c2f1fdab46710602994ee6ab5.svg";
export { ForwardRef as ReactComponent };